import { useParams } from "react-router-dom";
import { useGetFormQuery } from "../../services/form/api";

function useGetFormQueryByParam(options = {}) {
  const { type, id } = useParams();
  const canFetchForm = type && id
  const response = useGetFormQuery({ formType: type, id }, {
    skip: !canFetchForm,
    ...options
  })

  return response
}

export default useGetFormQueryByParam;
